import type { Component } from 'solid-js';
import CapitanPanel, { type CapitanLaunchParams } from './CapitanPanel';

/** Factory for Dashboard openInSplitView — returns a component constructor. */
export function createCapitanSplitPanel(launch: CapitanLaunchParams): () => Component {
  return () => {
    const Panel: Component = () => <CapitanPanel isInSplitView launchParams={launch} />;
    return Panel;
  };
}
